import MUILink from '@mui/material/Link';

type MUILinkProps = {
  rel?: string;
} & React.ComponentProps<typeof MUILink>;

const Link = ({
  children,
  rel = 'noopener',
  ...props
}: Readonly<MUILinkProps>) => {
  return (
    <MUILink {...props} rel={rel}>
      {children}
    </MUILink>
  );
};

export default Link;
